import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanDeactivate,
	RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { MyAccountComponent } from '../../my-account/my-account.component';

@Injectable()
export class MyAccountCanDeactivate
	implements CanDeactivate<MyAccountComponent>
{
	canDeactivate(
		component: MyAccountComponent,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState: RouterStateSnapshot
	): Observable<boolean> {
		if (component?.haveUnsavedChanges) {
			component.showConfirmationDialog = true;
			component.redirectPath = nextState.url;
		}
		return of(!component?.haveUnsavedChanges);
	}
}
